export default (storeState, { payload }) => {
  let newState = Object.assign({}, storeState);
  newState.settings.id_string = payload

  return newState;
};
